import { LitElement, html, svg } from 'lit';

export class IconPlay24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Sirkel med en trekant som peker til høyre</title><circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.5"></circle><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 17V7l8 5-8 5Z"></path></svg>`; }
}
if (!customElements.get('f-icon-play24', IconPlay24)) {
  customElements.define('f-icon-play24', IconPlay24);
}